import ContractStore from '../stores/ContractStore'
import Web3Store from '../stores/Web3Store'

export async function makeCustomWager(betId,
    endTime,
    reportingEndTime,
    makerChoice,
    value,
    odds) {
    return ContractStore.exec("CustomWagersController", "makeWager", [
        betId,
        endTime,
        reportingEndTime,
        makerChoice,
        value,
        odds
    ], {
            from: Web3Store.account,
            value: value
        });
}

export async function addJudge(betId, judgeAddress) {
    return ContractStore.exec("CustomWagersController", "addJudge", [
        betId,
        judgeAddress
    ], {
            from: Web3Store.account,
        });
}


export async function takeCustomWager(betId, judgeAddress, valueInWei) {
    return ContractStore.exec("CustomWagersController", "takeWager", [
        betId,
        judgeAddress
    ], {
            from: Web3Store.account,
            value: valueInWei
        });
}

export async function submitVote(betId, winnerVote) {
    return ContractStore.exec("CustomWagersController", "submitVote", [
        betId,
        winnerVote
    ], {
            from: Web3Store.account
        });
}

export async function submitJudgeVote(betId, winnerVote) {
    return ContractStore.exec("CustomWagersController", "submitJudgeVote", [
        betId,
        winnerVote
    ], {
            from: Web3Store.account
        });
}

export async function finalizeAbandonedBet(betId) {
    return ContractStore.exec("CustomWagersController", "finalizeAbandonedBet", [
        betId
    ], {
            from: Web3Store.account
        });
}



// WEBPACK FOOTER //
// ./src/contract/CustomWagersController.js